module.exports = __webpack_public_path__ + "23a83618b29ba2a32b2998c20dc8c949.png";